import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';

import * as ViewsActions from './views.actions';
import type { ExtraOption, PricingSettingItem, PricingSettings } from '../../models/settings';
import { ApiService } from '../../services/api.service';
import { toCamelCase } from '../../shared/utilities/case-conversion';
import { SETTINGSCONFIG } from '../../templates/views/settings/settings-config';

@Injectable()
export class ViewsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly apiService = inject(ApiService);

  loadPricingSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewsActions.loadPricingSettings),
      switchMap(() =>
        this.apiService.post(SETTINGSCONFIG.getExtrasOptions, {}).pipe(
          map((response) => {
            const pricingArray = toCamelCase(response.data) as PricingSettingItem[];

            const kmItem = pricingArray.find((i) =>
              i.type.toLowerCase().includes('kilometer allowance')
            );
            const kmItemPrice = pricingArray.find((i) =>
              i.type.toLowerCase().includes('unlimited km allowance price')
            );
            const superCollision = pricingArray.find((i) =>
              i.type.toLowerCase().includes('super collision damage')
            );
            const carDelivery = pricingArray.find((i) =>
              i.type.toLowerCase().includes('car delivery')
            );

            const extras: ExtraOption[] = pricingArray
              .filter(
                (i) =>
                  !i.type.toLowerCase().includes('kilometer allowance') &&
                  !i.type.toLowerCase().includes('super collision damage') &&
                  !i.type.toLowerCase().includes('car delivery') &&
                  !i.type.toLowerCase().includes('unlimited km allowance price')
              )
              .map(({ id, type, typeAr, price, code, range }) => ({
                id,
                type,
                typeAr,
                price: price || '0',
                code,
                range: range || 0,
              }));

            const settings: PricingSettings = {
              kmAllowance: kmItem?.range || 0,
              superCollisionCost: superCollision?.price || '0',
              carDeliveryCost: carDelivery?.price || '0',
              unlimitedKMAllownceCost: kmItemPrice?.price || '0',
              extras,
              pricingArray: pricingArray.map(({ id, type, typeAr, price, code, range }) => ({
                id,
                type,
                typeAr,
                price: price || '0',
                code,
                range: range || 0,
              })),
            };

            return ViewsActions.loadPricingSettingsSuccess({ settings });
          }),
          catchError((error) => of(ViewsActions.loadPricingSettingsFailure({ error })))
        )
      )
    )
  );
}
